module.exports = __webpack_public_path__ + "static/offices-floor-schema-6509e09ec5430c300190bc9833bcf691.jpg";